import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import "./Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faEye,  
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,faTag,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone,
    faEnvelope, faMapMarkerAlt, faTaag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faTruck, faBuilding, faGlobe, faUserTag, faStickyNote, faExternalLinkAlt,
    faHandshake, faFileContract, faMoneyBillWave, faPercent, faClock,
    faIdCard, faUserTie, faAddressCard, faFileAlt, faBoxes, faList
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// ============================================
// SHARED TRANSLATOR FOR PARTNER LIST
// ============================================
const createPartnerListTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Partners List': 'پارٹنرز کی فہرست',
                'All partners details are below': 'تمام پارٹنرز کی تفصیلات نیچے ہیں',
                'Partner Name': 'پارٹنر کا نام',
                'Partnership Type': 'شراکت کی قسم',
                'Products': 'مصنوعات',
                'Phone': 'فون نمبر',
                'Email': 'ای میل',
                'Address': 'پتہ',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search partners...': 'پارٹنرز تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'Partner Details': 'پارٹنر کی تفصیلات',
                'Contact Information': 'رابطہ کی معلومات',
                'Address Information': 'پتے کی معلومات',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view partners': 'براہ کرم پارٹنرز دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Partners': 'پارٹنرز',
                'Shop': 'شاپ',
                'View': 'دیکھیں',
                'Update Partner': 'پارٹنر اپڈیٹ کریں',
                'Updating...': 'اپڈیٹ ہو رہا ہے...',
                'Partner updated successfully': 'پارٹنر کامیابی سے اپڈیٹ ہو گیا',
                'Error updating partner': 'پارٹنر اپڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Partner Report': 'پارٹنر رپورٹ',
                'Partner Directory': 'پارٹنر ڈائریکٹری',
                'Total Partners': 'کل پارٹنرز',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Notes': 'نوٹس',
                'Investment Amount': 'سرمایہ کاری کی رقم',
                'Profit %': 'منافع کا فیصد',
                'Duration': 'مدت',
                'Contract': 'معاہدہ',
                'View Contract': 'معاہدہ دیکھیں',
                'No Contract': 'کوئی معاہدہ نہیں',
                'Status': 'حالت',
                'Active': 'فعال',
                'Inactive': 'غیر فعال',
                'Suspended': 'معطل',
                'Description': 'تفصیل',
                'Terminated': 'ختم شدہ',
                'All Type': 'تمام قسم',
                'Product Based': 'مصنوعات کی بنیاد پر',
                'No Products': 'کوئی مصنوعات نہیں'
            },
            'ar': {
                'Partners List': 'قائمة الشركاء',
                'All partners details are below': 'جميع تفاصيل الشركاء أدناه',
                'Partner Name': 'اسم الشريك',
                'Partnership Type': 'نوع الشراكة',
                'Products': 'المنتجات',
                'Phone': 'رقم الهاتف',
                'Email': 'البريد الإلكتروني',
                'Address': 'العنوان',
                'Actions': 'الإجراءات',
                'Added By': 'أضيف بواسطة',
                'Search partners...': 'بحث عن شركاء...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'Close': 'إغلاق',
                'Save Changes': 'حفظ التغييرات',
                'Cancel': 'إلغاء',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'All': 'الكل',
                'Partner Details': 'تفاصيل الشريك',
                'Contact Information': 'معلومات الاتصال',
                'Address Information': 'معلومات العنوان',
                'Switch Shop': 'تبديل المتجر',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view partners': 'الرجاء اختيار متجر لعرض الشركاء',
                'S.No': 'رقم',
                'Partners': 'الشركاء',
                'Shop': 'متجر',
                'View': 'عرض',
                'Update Partner': 'تحديث الشريك',
                'Updating...': 'جاري التحديث...',
                'Partner updated successfully': 'تم تحديث الشريك بنجاح',
                'Error updating partner': 'خطأ في تحديث الشريك',
                'Confirm Delete': 'تأكيد الحذف',
                'Yes, Delete': 'نعم، حذف',
                'No, Cancel': 'لا، إلغاء',
                'Portrait': 'عمودي',
                'Landscape': 'أفقي',
                'A4': 'A4',
                'Letter': 'رسالة',
                'Legal': 'قانوني',
                'A5': 'A5',
                'Partner Report': 'تقرير الشركاء',
                'Partner Directory': 'دليل الشركاء',
                'Total Partners': 'إجمالي الشركاء',
                'Generated': 'تم الإنشاء',
                'Report ID': 'معرف التقرير',
                'Generated by': 'تم الإنشاء بواسطة',
                'Shop Code': 'رمز المتجر',
                'FILTERS APPLIED': 'المرشحات المطبقة',
                'Search': 'بحث',
                'From': 'من',
                'To': 'إلى',
                'Page': 'صفحة',
                'Notes': 'ملاحظات',
                'Investment Amount': 'مبلغ الاستثمار',
                'Profit %': 'نسبة الربح',
                'Duration': 'المدة',
                'Contract': 'العقد',
                'View Contract': 'عرض العقد',
                'No Contract': 'لا يوجد عقد',
                'Status': 'الحالة',
                'Active': 'نشط',
                'Inactive': 'غير نشط',
                'Suspended': 'معلق',
                'Description': 'الوصف',
                'Terminated': 'منتهي',
                'All Type': 'جميع الأنواع',
                'Product Based': 'قائم على المنتج',
                'No Products': 'لا توجد منتجات'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        partnerList: 'Partners List',
        formDetails: 'All partners details are below',
        partners: 'Partners',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search partners...',
        refresh: 'Refresh',
        loadingUserData: 'Loading your partner data...',
        selectShop: 'Please select a shop to view partners',
        partnerName: 'Partner Name',
        partnershipType: 'Partnership Type',
        products: 'Products',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        actions: 'Actions',
        addedBy: 'Added By',
        edit: 'Edit',
        delete: 'Delete',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        partnerNameFilter: 'Partner Name',
        partnershipTypeFilter: 'Partnership Type',
        phoneFilter: 'Phone Number',
        emailFilter: 'Email',
        addressFilter: 'Address',
        addedByFilter: 'Added By',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        partnerDetails: 'Partner Details',
        contactInfo: 'Contact Information',
        addressInfo: 'Address Information',
        editPartner: 'Edit Partner',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this partner?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        partnerReport: 'Partner Report',
        partnerDirectory: 'Partner Directory',
        totalPartners: 'Total Partners',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        investmentAmount: 'Investment Amount',
        profitPercent: 'Profit %',
        duration: 'Duration',
        contract: 'Contract',
        viewContract: 'View Contract',
        noContract: 'No Contract',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended',
        terminated: 'Terminated',
        description: 'Description',
        notes: 'Notes',
        allType: 'All Type Partnership',
        productBased: 'Product Based Partnership',
        allTypeShort: 'All Type',
        productBasedShort: 'Product Based',
        noProducts: 'No Products'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const partnerListTranslator = createPartnerListTranslator();

const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success':
                return faCheckCircle;
            case 'error':
                return faExclamationTriangle;
            case 'warning':
                return faExclamationTriangle;
            case 'info':
                return faCheckCircle;
            default:
                return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success':
                return translations.success || 'Success';
            case 'error':
                return translations.error || 'Error';
            case 'warning':
                return translations.warning || 'Warning';
            case 'info':
                return 'Info';
            default:
                return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};


// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Custom Dropdown Component
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [isHovering, setIsHovering] = useState(false);
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const menuRef = useRef(null);
    const hoverTimeoutRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        if (!isHovering) {
            setSearchTerm(displayValue);
        }
    }, [displayValue, isHovering]);

    useEffect(() => {
        if (isOpen) {
            const event = new CustomEvent('dropdownOpened', { detail: { id: label } });
            window.dispatchEvent(event);
        }
    }, [isOpen, label]);

    useEffect(() => {
        const handleDropdownOpened = (event) => {
            if (event.detail && event.detail.id !== label) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        window.addEventListener('dropdownOpened', handleDropdownOpened);
        return () => window.removeEventListener('dropdownOpened', handleDropdownOpened);
    }, [label]);

    const filteredOptions = isHovering
        ? options
        : searchTerm.trim() === ''
            ? options
            : options.filter(opt =>
                opt.label.toLowerCase().includes(searchTerm.toLowerCase())
            );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        setHighlightedIndex(-1);
        setIsHovering(false);
    };

    const handleKeyDown = (e) => {
        if (!isOpen) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(true);
                setHighlightedIndex(0);
                setIsHovering(false);
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev => 
                    prev < filteredOptions.length - 1 ? prev + 1 : prev
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
                    handleSelect(filteredOptions[highlightedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            case 'Tab':
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            default:
                break;
        }
    };

    const handleMouseEnter = () => {
        if (disabled) return;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        hoverTimeoutRef.current = setTimeout(() => {
            setIsHovering(true);
            setIsOpen(true);
            setHighlightedIndex(0);
        }, 200);
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        setTimeout(() => {
            if (!isOpen) {
                setIsHovering(false);
            }
        }, 300);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (highlightedIndex >= 0 && menuRef.current) {
            const items = menuRef.current.querySelectorAll('.ozlistui-custom-dropdown-option');
            if (items[highlightedIndex]) {
                items[highlightedIndex].scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex]);

    const handleInputClick = () => {
        if (disabled) return;
        setIsHovering(false);
        setSearchTerm(displayValue);
        setIsOpen(true);
        setHighlightedIndex(0);
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setIsHovering(false);
        setSearchTerm(newValue);
        setIsOpen(true);
        setHighlightedIndex(0);
        if (!options.find(opt => opt.label.toLowerCase() === newValue.toLowerCase())) {
            onChange('');
        }
    };

    return (
        <div 
            className="ozlistui-custom-dropdown-wrapper" 
            ref={wrapperRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="ozlistui-custom-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    onFocus={() => {
                        if (!disabled) {
                            setIsHovering(false);
                            setSearchTerm(displayValue);
                            setIsOpen(true);
                            setHighlightedIndex(0);
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu" ref={menuRef}>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt, index) => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''} ${highlightedIndex === index ? 'ozlistui-highlighted' : ''}`}
                                onClick={() => handleSelect(opt)}
                                onMouseEnter={() => setHighlightedIndex(index)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Accept every selected_products shape returned by old and new API versions.
const parseSelectedProductIds = (selectedProducts, productDetails = []) => {
    if (Array.isArray(selectedProducts)) {
        return selectedProducts
            .map(item => Number(typeof item === 'object' ? (item.id ?? item.product_id) : item))
            .filter(id => Number.isInteger(id) && id > 0);
    }

    if (typeof selectedProducts === 'string' && selectedProducts.trim()) {
        const raw = selectedProducts.trim();
        if (raw.startsWith('[')) {
            try {
                return parseSelectedProductIds(JSON.parse(raw), productDetails);
            } catch (error) {
                console.warn('Invalid selected_products JSON:', raw, error);
            }
        }
        const ids = raw.split(',').map(id => Number(id.trim())).filter(id => Number.isInteger(id) && id > 0);
        if (ids.length) return [...new Set(ids)];
    }

    if (Array.isArray(productDetails)) {
        return [...new Set(productDetails
            .map(product => Number(product.id ?? product.product_id))
            .filter(id => Number.isInteger(id) && id > 0))];
    }
    return [];
};

// ============================================
// MAIN COMPONENT - SolarPartnersList
// ============================================
const SolarPartnersList = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [partners, setPartners] = useState([]);
    const [filteredPartners, setFilteredPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [partnerToDelete, setPartnerToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [editContractFile, setEditContractFile] = useState(null);
    const [showFilters, setShowFilters] = useState(false);

    // PDF Options State
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 650, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 850, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        partner_name: '',
        phone: '',
        email: '',
        address: '',
        partnership_type: 'ALL',
        partnership_duration: '',
        investment_amount: '',
        profit_percentage: '',
        description: '',
        notes: '',
        contract_start_date: '',
        contract_end_date: '',
        status: 'active',
        partnership_contract: '',
        selected_products: [],
        product_selection_mode: 'multiple',
        expenses_salaries_included: false
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    // Partnership Type Options
    const partnershipTypeOptions = [
        { value: 'ALL', label: 'All Type Partnership' },
        { value: 'Product Based', label: 'Product Based Partnership' }
    ];

    // Duration Options
    const durationOptions = [
        { value: '', label: 'Select Duration' },
        { value: '3_months', label: '3 Months' },
        { value: '6_months', label: '6 Months' },
        { value: '1_year', label: '1 Year' },
        { value: '2_years', label: '2 Years' },
        { value: '3_years', label: '3 Years' },
        { value: '5_years', label: '5 Years' },
        { value: 'lifetime', label: 'Lifetime' },
        { value: 'custom', label: 'Custom Duration' }
    ];

    // Status Options
    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'suspended', label: 'Suspended' },
        { value: 'terminated', label: 'Terminated' }
    ];

    // Business info state
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        businessaddress: '',
        fullname: '',
        email: ''
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    // Filter states
    const [filterBy, setFilterBy] = useState('');
    const [partnerNameFilter, setPartnerNameFilter] = useState('');
    const [partnershipTypeFilter, setPartnershipTypeFilter] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');
    const [emailFilter, setEmailFilter] = useState('');
    const [addressFilter, setAddressFilter] = useState('');
    const [addedByFilter, setAddedByFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const filterByOptions = useMemo(() => [
        { value: 'all', label: translations.all || 'All' },
        { value: 'partnerName', label: translations.partnerNameFilter || 'Partner Name' },
        { value: 'partnershipType', label: translations.partnershipTypeFilter || 'Partnership Type' },
        { value: 'phone', label: translations.phoneFilter || 'Phone Number' },
        { value: 'email', label: translations.emailFilter || 'Email' },
        { value: 'address', label: translations.addressFilter || 'Address' },
        { value: 'added_by', label: translations.addedByFilter || 'Added By' }
    ], [translations]);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    const pdfPageRangeOptions = useMemo(() => [
        { value: 'all', label: 'All Pages' },
        { value: 'range', label: 'Page Range' }
    ], []);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // THEME SYNC
    // ============================================
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
            setCurrentTheme(color);
        };

        applyTheme(currentTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentTheme) {
                applyTheme(storedTheme);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [currentTheme]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);

            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozlistui-dark');
                } else {
                    container.classList.remove('ozlistui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozlistui-dark');
                document.documentElement.classList.add('ozlistui-dark');
            } else {
                document.body.classList.remove('ozlistui-dark');
                document.documentElement.classList.remove('ozlistui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await partnerListTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Center modal function
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showEditModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showEditModal]);

    // ============================================
    // FETCH PARTNERS
    // ============================================
    const fetchPartners = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }
        if (isMountedRef.current) setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/solar_module/solar_partners.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'list',
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });

            const responseText = await response.text();
            
            if (!responseText || responseText.trim() === '') {
                throw new Error('Empty response from server');
            }

            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error. Raw response:', responseText.substring(0, 500));
                throw new Error('Invalid JSON response from server');
            }

            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setPartners(data.partners || []);
                    resetFilters();
                } else {
                    showToast('error', data.message || translations.networkError || 'Network error occurred');
                }
            }
        } catch (error) {
            console.error('Error fetching partners:', error);
            if (isMountedRef.current) showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        businessaddress: data.businessaddress || '',
                        fullname: data.fullname || '',
                        email: data.email || ''
                    });
                } else {
                    setBusinessInfo({
                        businessname: user.business_name || '',
                        bussinesslogo: '',
                        businessaddress: '',
                        fullname: user.fullname || '',
                        email: user.email || ''
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || '',
                    bussinesslogo: '',
                    businessaddress: '',
                    fullname: user.fullname || '',
                    email: user.email || ''
                });
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchPartners();
            fetchBusinessInfo();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                resetFilters();
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast]);

    // ============================================
    // FILTERS
    // ============================================
    const applyFilters = useCallback(() => {
        let filtered = [...partners];
        
        // Search term filter
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(partner =>
                partner.partner_name?.toLowerCase().includes(term) ||
                partner.phone?.toLowerCase().includes(term) ||
                partner.email?.toLowerCase().includes(term) ||
                partner.address?.toLowerCase().includes(term) ||
                partner.partnership_type?.toLowerCase().includes(term) ||
                partner.description?.toLowerCase().includes(term) ||
                partner.notes?.toLowerCase().includes(term) ||
                partner.partner_id?.toString().includes(term)
            );
        }

        // Specific filters
        if (filterBy === 'partnerName' && partnerNameFilter.trim()) {
            const term = partnerNameFilter.toLowerCase();
            filtered = filtered.filter(partner => partner.partner_name?.toLowerCase().includes(term));
        }
        
        if (filterBy === 'partnershipType' && partnershipTypeFilter) {
            filtered = filtered.filter(partner => partner.partnership_type === partnershipTypeFilter);
        }
        
        if (filterBy === 'phone' && phoneFilter.trim()) {
            const term = phoneFilter.toLowerCase();
            filtered = filtered.filter(partner => partner.phone?.toLowerCase().includes(term));
        }
        
        if (filterBy === 'email' && emailFilter.trim()) {
            const term = emailFilter.toLowerCase();
            filtered = filtered.filter(partner => partner.email?.toLowerCase().includes(term));
        }
        
        if (filterBy === 'address' && addressFilter.trim()) {
            const term = addressFilter.toLowerCase();
            filtered = filtered.filter(partner => partner.address?.toLowerCase().includes(term));
        }
        
        if (filterBy === 'added_by' && addedByFilter.trim()) {
            const term = addedByFilter.toLowerCase();
            filtered = filtered.filter(partner => partner.username?.toLowerCase().includes(term));
        }

        // Status filter
        if (statusFilter) {
            filtered = filtered.filter(partner => partner.status === statusFilter);
        }

        // Date range filter
        if (startDate) {
            filtered = filtered.filter(partner => {
                if (!partner.created_at) return false;
                return partner.created_at.split('T')[0] >= startDate;
            });
        }
        if (endDate) {
            filtered = filtered.filter(partner => {
                if (!partner.created_at) return false;
                return partner.created_at.split('T')[0] <= endDate;
            });
        }

        setFilteredPartners(filtered);
        setCurrentPage(1);
    }, [partners, searchTerm, filterBy, partnerNameFilter, partnershipTypeFilter, phoneFilter, emailFilter, addressFilter, addedByFilter, statusFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    const resetFilters = useCallback(() => {
        setFilterBy('');
        setPartnerNameFilter('');
        setPartnershipTypeFilter('');
        setPhoneFilter('');
        setEmailFilter('');
        setAddressFilter('');
        setAddedByFilter('');
        setStatusFilter('');
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
    }, []);

    const handleSearch = useCallback(() => { applyFilters(); }, [applyFilters]);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    }, []);

    const formatDateGlobal = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    };

    const currentDateGlobal = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getTodayDate = useCallback(() => new Date().toISOString().split('T')[0], []);
    const getRowsPerPage = useCallback(() => pdfOrientation === 'landscape' ? 20 : 15, [pdfOrientation]);

    // ============================================
    // PAGINATION
    // ============================================
    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredPartners.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentPartners = filteredPartners.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentPartners };
    }, [filteredPartners, currentPage, itemsPerPage]);

    // ============================================
    // PDF EXPORT
    // ============================================
    // PDF EXPORT FUNCTION - vector based (no DOM, canvas or image conversion)
    const exportToPDF = useCallback(() => {
        if (!filteredPartners?.length) {
            showToast('warning', translations.noDataToExport || 'No data to export');
            return;
        }

        setPdfLoading(true);
        try {
            const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
            const t = (key, fallback) => translations[key] || fallback;
            const pageFormat = { a4: 'a4', letter: 'letter', legal: 'legal', a5: 'a5' }[pdfPageSize] || 'a4';
            const doc = new jsPDF({
                orientation: pdfOrientation,
                unit: 'mm',
                format: pageFormat,
                compress: true
            });

            const themeRgb = (() => {
                const hex = String(currentTheme || '#2563eb').replace('#', '');
                const normalized = hex.length === 3
                    ? hex.split('').map(char => char + char).join('')
                    : hex.padEnd(6, '0').slice(0, 6);
                return [0, 2, 4].map(index => parseInt(normalized.slice(index, index + 2), 16) || 0);
            })();
            const margin = 12;
            const rowsPerRangePage = getRowsPerPage();
            let partnersToExport = [...filteredPartners];

            if (pdfPageRange === 'range') {
                const availablePages = Math.ceil(partnersToExport.length / rowsPerRangePage);
                const firstPage = Math.min(Math.max(1, Number(pdfStartPage) || 1), availablePages);
                const lastPage = Math.min(
                    Math.max(firstPage, Number(pdfEndPage) || firstPage),
                    availablePages
                );
                partnersToExport = partnersToExport.slice(
                    (firstPage - 1) * rowsPerRangePage,
                    lastPage * rowsPerRangePage
                );
            }

            const generatedAt = new Date();
            const reportId = `${currentDateGlobal().replace(/-/g, '')}-${String(generatedAt.getTime()).slice(-6)}`;
            const pageWidth = doc.internal.pageSize.getWidth();
            const getProductNames = (partner) => {
                if (partner.partnership_type !== 'Product Based') return '-';
                const names = Array.isArray(partner.product_details)
                    ? partner.product_details.map(product => product.product_name).filter(Boolean)
                    : [];
                if (names.length) return names.join(', ');
                const selectedIds = String(partner.selected_products || '').split(',').filter(id => id.trim());
                return selectedIds.length ? `${selectedIds.length} product(s)` : '-';
            };
            const getPartnershipLabel = (type) => type === 'ALL'
                ? t('allTypeShort', 'All Type')
                : t('productBasedShort', 'Product Based');
            const getStatusLabel = (status) => ({
                active: t('active', 'Active'),
                inactive: t('inactive', 'Inactive'),
                suspended: t('suspended', 'Suspended'),
                terminated: t('terminated', 'Terminated')
            }[status] || status || t('active', 'Active'));

            const tableColumns = [
                t('serialNo', 'S.No'),
                t('partnerName', 'Partner Name'),
                t('partnershipType', 'Partnership Type'),
                t('products', 'Products'),
                t('phone', 'Phone'),
                t('email', 'Email'),
                t('address', 'Address'),
                t('status', 'Status'),
                t('addedBy', 'Added By')
            ];
            const tableRows = partnersToExport.map((partner, index) => [
                index + 1,
                partner.partner_name || '-',
                getPartnershipLabel(partner.partnership_type),
                getProductNames(partner),
                partner.phone || '-',
                partner.email || '-',
                partner.address || '-',
                getStatusLabel(partner.status),
                partner.username || '-'
            ]);

            const activeFilters = [
                searchTerm && `${t('search', 'Search')}: "${searchTerm}"`,
                partnershipTypeFilter && `${t('partnershipType', 'Partnership Type')}: ${getPartnershipLabel(partnershipTypeFilter)}`,
                startDate && `${t('from', 'From')}: ${startDate}`,
                endDate && `${t('to', 'To')}: ${endDate}`
            ].filter(Boolean).join('  |  ');
            const drawReportHeader = () => {
                doc.setTextColor(107, 114, 128);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(7);
                doc.text(t('partnerReport', 'PARTNER REPORT').toUpperCase(), pageWidth / 2, 11, { align: 'center' });

                doc.setTextColor(31, 41, 55);
                doc.setFontSize(17);
                doc.text(currentShop?.shop_name || t('partnerDirectory', 'Partner Directory'), pageWidth / 2, 19, { align: 'center' });

                doc.setDrawColor(...themeRgb);
                doc.setLineWidth(0.8);
                doc.line(pageWidth / 2 - 10, 23, pageWidth / 2 + 10, 23);

                let detailY = 28;
                if (businessInfo.businessname) {
                    doc.setTextColor(107, 114, 128);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8);
                    doc.text(businessInfo.businessname, pageWidth / 2, detailY, { align: 'center' });
                    detailY += 4;
                }

                doc.setFontSize(7);
                doc.text(
                    `${t('totalPartners', 'Total Partners')}: ${partnersToExport.length}  |  ${t('generated', 'Generated')}: ${generatedAt.toLocaleString(currentLanguage)}`,
                    pageWidth / 2,
                    detailY,
                    { align: 'center' }
                );

                const metaY = detailY + 6;
                doc.setDrawColor(229, 231, 235);
                doc.setLineWidth(0.2);
                doc.line(margin, metaY - 3, pageWidth - margin, metaY - 3);
                doc.line(margin, metaY + 2, pageWidth - margin, metaY + 2);
                doc.setFontSize(6.5);
                doc.text(`${t('reportId', 'Report ID')}: #${reportId}`, margin, metaY);
                doc.text(
                    `${t('generatedBy', 'Generated by')}: ${user?.fullname || user?.username || 'System'}`,
                    pageWidth / 2,
                    metaY,
                    { align: 'center' }
                );
                doc.text(
                    `${t('shopCode', 'Shop Code')}: ${currentShop?.shop_code || 'N/A'}`,
                    pageWidth - margin,
                    metaY,
                    { align: 'right' }
                );

                if (activeFilters) {
                    doc.setFillColor(249, 250, 251);
                    doc.setDrawColor(...themeRgb);
                    doc.setLineWidth(0.8);
                    doc.rect(margin, metaY + 5, pageWidth - margin * 2, 7, 'F');
                    doc.line(isRTL ? pageWidth - margin : margin, metaY + 5, isRTL ? pageWidth - margin : margin, metaY + 12);
                    doc.setTextColor(75, 85, 99);
                    doc.setFontSize(6.5);
                    doc.text(`${t('filtersApplied', 'FILTERS APPLIED')}: ${activeFilters}`, margin + 3, metaY + 9.5, {
                        maxWidth: pageWidth - margin * 2 - 6,
                        align: isRTL ? 'right' : 'left'
                    });
                }
            };

            autoTable(doc, {
                head: [tableColumns],
                body: tableRows,
                startY: activeFilters ? 49 : 42,
                margin: { top: activeFilters ? 49 : 42, right: margin, bottom: 14, left: margin },
                theme: 'grid',
                showHead: 'everyPage',
                styles: {
                    font: 'helvetica',
                    fontSize: pdfOrientation === 'landscape' ? 7 : 6.5,
                    cellPadding: 2,
                    lineColor: [229, 231, 235],
                    lineWidth: 0.15,
                    textColor: [31, 41, 55],
                    overflow: 'linebreak',
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: themeRgb,
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                    lineColor: themeRgb,
                    minCellHeight: 8
                },
                alternateRowStyles: { fillColor: [249, 250, 251] },
                columnStyles: {
                    0: { cellWidth: 8, halign: 'center' },
                    1: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left', fontStyle: 'bold' },
                    2: { cellWidth: 24, halign: 'center' },
                    3: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left' },
                    4: { cellWidth: 22, halign: 'center' },
                    5: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left' },
                    6: { cellWidth: 'auto', halign: isRTL ? 'right' : 'left' },
                    7: { cellWidth: 18, halign: 'center' },
                    8: { cellWidth: 20, halign: 'center' }
                },                didDrawPage: ({ pageNumber }) => {
                    drawReportHeader();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const pageCount = doc.internal.getNumberOfPages();
                    doc.setDrawColor(229, 231, 235);
                    doc.setLineWidth(0.2);
                    doc.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
                    doc.setTextColor(107, 114, 128);
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(7);
                    doc.text(
                        `${t('page', 'Page')} ${pageNumber} ${t('of', 'of')} ${pageCount}`,
                        pageWidth / 2,
                        pageHeight - 6,
                        { align: 'center' }
                    );
                }
            });

            // AutoTable only knows the final page count after layout; refresh all footers.
            const finalPageCount = doc.internal.getNumberOfPages();
            for (let page = 1; page <= finalPageCount; page += 1) {
                doc.setPage(page);
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.setFillColor(255, 255, 255);
                doc.rect(0, pageHeight - 11, pageWidth, 11, 'F');
                doc.setDrawColor(229, 231, 235);
                doc.line(margin, pageHeight - 10, pageWidth - margin, pageHeight - 10);
                doc.setTextColor(107, 114, 128);
                doc.setFontSize(7);
                doc.text(`${t('page', 'Page')} ${page} ${t('of', 'of')} ${finalPageCount}`, pageWidth / 2, pageHeight - 6, { align: 'center' });
            }

            const safeShopName = (currentShop?.shop_name || 'Export').replace(/[^a-z0-9_-]/gi, '_');
            doc.save(`Partner_Report_${safeShopName}_${currentDateGlobal()}.pdf`);
            showToast(
                'success',
                `${t('reportGenerated', 'Report generated!')} ${partnersToExport.length} ${t('partners', 'partners')} ${t('on', 'on')} ${finalPageCount} ${t('pages', 'page(s)')}`
            );
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', translations.pdfGenerationError || 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [filteredPartners, currentLanguage, pdfOrientation, pdfPageSize, pdfPageRange, pdfStartPage, pdfEndPage, translations, businessInfo, currentShop, user, showToast, getRowsPerPage, searchTerm, partnershipTypeFilter, startDate, endDate, currentTheme]);

    // ============================================
    // HANDLE VIEW CONTRACT
    // ============================================
    const handleViewContract = useCallback((contractPath) => {
        if (!contractPath) {
            showToast('warning', translations.noContract || 'No contract available');
            return;
        }
        const contractUrl = `https://ourzestapp.online/oz_backend/solar_module/uploads/contracts/${contractPath}`;
        window.open(contractUrl, '_blank');
    }, [translations, showToast]);

    // ============================================
    // HANDLE VIEW PARTNER
    // ============================================
    const handleView = useCallback((partner) => { 
        setSelectedPartner(partner); 
        setShowViewModal(true); 
    }, []);

    const fetchProductsForEdit = useCallback(async () => {
        if (!currentShop) return;
        setLoadingProducts(true);
        try {
            // Use the same working product source as Partner.js. Do not call the
            // solar get_products action first, because older deployed PHP copies
            // query a non-existent mechanics_products.status column and return 400.
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records',
                    username: user?.username || '',
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (!response.ok || data.status !== 'success') {
                throw new Error(data.message || 'Failed to load products');
            }
            const products = Array.isArray(data.data) ? data.data : (Array.isArray(data.products) ? data.products : []);
            const normalizedProducts = products.map(product => ({
                ...product,
                id: Number(product.id ?? product.product_id)
            })).filter(product => Number.isInteger(product.id) && product.id > 0);
            setAvailableProducts(normalizedProducts);
            return normalizedProducts;
        } catch (error) {
            console.error('Error loading products:', error);
            showToast('error', error.message || 'Failed to load products');
            setAvailableProducts([]);
            return [];
        } finally {
            setLoadingProducts(false);
        }
    }, [currentShop, user?.username, showToast]);

    // Product names are needed by the list even before the user opens Edit.
    useEffect(() => {
        if (currentShop) fetchProductsForEdit();
        else setAvailableProducts([]);
    }, [currentShop, fetchProductsForEdit]);

    // ============================================
    // HANDLE EDIT PARTNER
    // ============================================
    const handleEdit = useCallback((partner) => {
        const selectedProductIds = parseSelectedProductIds(partner.selected_products, partner.product_details);
        setSelectedPartner(partner);
        setEditFormData({
            partner_name: partner.partner_name || '',
            phone: partner.phone || '',
            email: partner.email || '',
            address: partner.address || '',
            partnership_type: partner.partnership_type || 'ALL',
            partnership_duration: partner.partnership_duration || '',
            investment_amount: partner.investment_amount || '',
            profit_percentage: partner.profit_percentage || '',
            description: partner.description || '',
            notes: partner.notes || '',
            contract_start_date: partner.contract_start_date || '',
            contract_end_date: partner.contract_end_date || '',
            status: partner.status || 'active',
            partnership_contract: partner.partnership_contract || '',
            selected_products: selectedProductIds,
            product_selection_mode: partner.product_selection_mode || 'multiple',
            expenses_salaries_included: Number(partner.expenses_salaries_included) === 1 || partner.expenses_salaries_included === true
        });
        setEditContractFile(null);
        setEditFormErrors({});
        setShowEditModal(true);
        if (partner.partnership_type === 'Product Based') fetchProductsForEdit();
    }, [fetchProductsForEdit]);

    // ============================================
    // HANDLE DELETE PARTNER
    // ============================================
    const handleDeleteClick = useCallback((partnerId) => {
        console.log('🔍 Delete clicked for partner ID:', partnerId);
        const partner = partners.find(p => p.partner_id === partnerId);
        if (!partner) {
            showToast('error', 'Partner not found');
            return;
        }
        if (partner.username !== user?.username) {
            showToast('error', 'You can only delete partners you added');
            return;
        }
        setPartnerToDelete(partnerId);
        setShowDeleteModal(true);
    }, [partners, user, showToast]);

    // ============================================
    // HANDLE DELETE CONFIRM
    // ============================================
    const handleDelete = useCallback(async () => {
        if (!partnerToDelete || !currentShop) {
            showToast('error', 'No partner selected or shop not found');
            return;
        }

        const partner = partners.find(p => p.partner_id === partnerToDelete);
        if (!partner) {
            showToast('error', 'Partner not found');
            setShowDeleteModal(false);
            setPartnerToDelete(null);
            return;
        }

        if (partner.username !== user?.username) {
            showToast('error', 'You can only delete your own partners');
            setShowDeleteModal(false);
            setPartnerToDelete(null);
            return;
        }

        console.log('🔍 Deleting partner:', partner);
        console.log('🔍 Partner ID:', partnerToDelete);

        const payload = {
            action: 'delete',
            partner_id: partnerToDelete,
            username: user.username,
            shop_id: currentShop.shop_id
        };

        console.log('📤 Sending delete payload:', payload);

        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/solar_module/solar_partners.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const responseText = await response.text();

            if (!responseText || responseText.trim() === '') {
                throw new Error('Empty response from server');
            }

            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error:', responseText);
                throw new Error('Invalid JSON response from server');
            }

            console.log('📥 Delete response:', data);

            if (data.status === 'success') {
                showToast('success', translations.deletedSuccess || 'Partner deleted successfully');
                fetchPartners();
                setShowDeleteModal(false);
                setPartnerToDelete(null);
            } else {
                showToast('error', data.message || translations.deleteError || 'Error deleting partner');
            }
        } catch (error) {
            console.error('Error deleting partner:', error);
            showToast('error', translations.deleteError || 'Error deleting partner: ' + error.message);
        }
    }, [partnerToDelete, currentShop, partners, user, translations, showToast, fetchPartners]);

    // ============================================
    // HANDLE UPDATE PARTNER
    // ============================================
    const uploadEditedContract = useCallback(async (file) => {
        if (!file) return editFormData.partnership_contract || null;
        const uploadData = new FormData();
        uploadData.append('file', file);
        uploadData.append('action', 'upload_contract');
        uploadData.append('username', user?.username || '');
        uploadData.append('shop_id', currentShop?.shop_id || '');
        const response = await fetch('https://ourzestapp.online/oz_backend/solar_module/solar_partners.php', {
            method: 'POST',
            body: uploadData
        });
        const data = await response.json();
        if (!response.ok || data.status !== 'success') {
            throw new Error(data.message || 'Contract upload failed');
        }
        return data.file_path || data.path || data.filename || null;
    }, [currentShop?.shop_id, editFormData.partnership_contract, user?.username]);

    const handleUpdatePartner = useCallback(async (e) => {
        e.preventDefault();
        if (!selectedPartner || !currentShop) {
            showToast('error', 'No partner selected or shop not found');
            return;
        }

        console.log('🔍 Updating partner:', selectedPartner);
        console.log('🔍 Partner ID:', selectedPartner.partner_id);

        const errors = {};
        if (!editFormData.partner_name.trim()) errors.partner_name = translations.partnerNameRequired || 'Partner name is required';
        if (editFormData.phone && !/^[\d\s\-\+\(\)]{10,15}$/.test(editFormData.phone)) errors.phone = translations.invalidPhone || 'Please enter a valid phone number';
        if (editFormData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editFormData.email)) errors.email = translations.invalidEmail || 'Please enter a valid email address';
        if (editFormData.partnership_type === 'Product Based' && editFormData.selected_products.length === 0) {
            errors.selected_products = 'Please select at least one product';
        }

        if (Object.keys(errors).length > 0) { 
            setEditFormErrors(errors); 
            return; 
        }

        setEditLoading(true);

        try {
        const contractPath = await uploadEditedContract(editContractFile);
        const payload = {
            action: 'update',
            partner_id: selectedPartner.partner_id,
            username: user.username,
            shop_id: currentShop.shop_id,
            partner_name: editFormData.partner_name,
            phone: editFormData.phone || null,
            email: editFormData.email || null,
            address: editFormData.address || null,
            partnership_type: editFormData.partnership_type || 'ALL',
            partnership_duration: editFormData.partnership_duration || null,
            investment_amount: editFormData.investment_amount || 0,
            profit_percentage: editFormData.profit_percentage || 0,
            description: editFormData.description || null,
            notes: editFormData.notes || null,
            contract_start_date: editFormData.contract_start_date || null,
            contract_end_date: editFormData.contract_end_date || null,
            status: editFormData.status || 'active',
            partnership_contract: contractPath,
            selected_products: editFormData.partnership_type === 'Product Based' ? editFormData.selected_products : [],
            product_selection_mode: editFormData.product_selection_mode || 'multiple',
            expenses_salaries_included: Boolean(editFormData.expenses_salaries_included)
        };

        console.log('📤 Sending update payload:', payload);

            const response = await fetch('https://ourzestapp.online/oz_backend/solar_module/solar_partners.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const responseText = await response.text();

            if (!responseText || responseText.trim() === '') {
                throw new Error('Empty response from server');
            }

            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error:', responseText);
                throw new Error('Invalid JSON response from server');
            }

            console.log('📥 Update response:', data);

            if (data.status === 'success') {
                showToast('success', translations.partnerUpdated || 'Partner updated successfully');
                setShowEditModal(false);
                fetchPartners();
            } else {
                showToast('error', data.message || translations.updateError || 'Error updating partner');
            }
        } catch (error) {
            console.error('Error updating partner:', error);
            showToast('error', translations.updateError || 'Error updating partner: ' + error.message);
        } finally {
            setEditLoading(false);
        }
    }, [selectedPartner, currentShop, editFormData, editContractFile, user, translations, showToast, fetchPartners, uploadEditedContract]);

    const handlePageChange = useCallback((page) => { 
        if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); 
    }, [pagination.totalPages]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // Get product names for display in the table
    const getProductNames = useCallback((partner) => {
        if (partner.partnership_type !== 'Product Based') return '-';

        let details = partner.product_details;
        if (typeof details === 'string') {
            try { details = JSON.parse(details); } catch (error) { details = []; }
        }

        if (Array.isArray(details) && details.length > 0) {
            const names = details.map(product => product.product_name || product.name).filter(Boolean);
            return names.length > 0 ? names.join(', ') : '-';
        }

        const ids = parseSelectedProductIds(partner.selected_products, details);
        if (ids.length > 0) {
            const productMap = new Map(availableProducts.map(product => [Number(product.id ?? product.product_id), product]));
            const names = ids.map(id => productMap.get(id)?.product_name || productMap.get(id)?.name).filter(Boolean);
            if (names.length > 0) return names.join(', ');
            return ids.map(id => `Product #${id}`).join(', ');
        }

        return '-';
    }, [availableProducts]);

    // ============================================
    // RENDER
    // ============================================
    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>
                                
                                {translations.partnerList || 'Partners List'}
                            </h1>
                            <p>{translations.formDetails || 'All partners details are below'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        <button 
                            className="ozlistui-header-filter-btn"
                            onClick={() => setShowFilters(!showFilters)}
                            title={showFilters ? "Hide Filters" : "Show Filters"}
                        >
                            <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                            <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                        </button>
                        
                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <CustomDropdown
                            label={translations.filterBy || 'Filter By'}
                            icon={faTag}
                            value={filterBy}
                            onChange={setFilterBy}
                            options={filterByOptions}
                            translations={translations}
                        />

                        {filterBy === 'partnerName' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="partnerNameFilter"
                                        value={partnerNameFilter}
                                        onChange={(e) => setPartnerNameFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="partnerNameFilter">
                                        <FontAwesomeIcon icon={faUserTie} />
                                        {translations.partnerNameFilter || 'Partner Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'partnershipType' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <select
                                        id="partnershipTypeFilter"
                                        value={partnershipTypeFilter}
                                        onChange={(e) => setPartnershipTypeFilter(e.target.value)}
                                    >
                                        <option value="">All Types</option>
                                        <option value="ALL">All Type Partnership</option>
                                        <option value="Product Based">Product Based Partnership</option>
                                    </select>
                                    <label htmlFor="partnershipTypeFilter">
                                        <FontAwesomeIcon icon={faHandshake} />
                                        {translations.partnershipTypeFilter || 'Partnership Type'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'phone' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="tel"
                                        id="phoneFilter"
                                        value={phoneFilter}
                                        onChange={(e) => setPhoneFilter(e.target.value)}
                                        placeholder=" "
                                        dir="ltr"
                                    />
                                    <label htmlFor="phoneFilter">
                                        <FontAwesomeIcon icon={faPhone} />
                                        {translations.phoneFilter || 'Phone Number'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'email' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="email"
                                        id="emailFilter"
                                        value={emailFilter}
                                        onChange={(e) => setEmailFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="emailFilter">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        {translations.emailFilter || 'Email'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'address' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="addressFilter"
                                        value={addressFilter}
                                        onChange={(e) => setAddressFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="addressFilter">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        {translations.addressFilter || 'Address'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'added_by' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="addedByFilter"
                                        value={addedByFilter}
                                        onChange={(e) => setAddedByFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="addedByFilter">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations.addedByFilter || 'Added By'}
                                    </label>
                                </div>
                            </div>
                        )}

                        <CustomDropdown
                            label={translations.orientation || 'Orientation'}
                            icon={faFilePdf}
                            value={pdfOrientation}
                            onChange={setPdfOrientation}
                            options={pdfOrientationOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.pageSize || 'Page Size'}
                            icon={faFilePdf}
                            value={pdfPageSize}
                            onChange={setPdfPageSize}
                            options={pdfPageSizeOptions}
                            translations={translations}
                        />

                        <div className="ozlistui-filter-group">
                            <button onClick={fetchPartners} className="ozlistui-refresh-btn" disabled={loading}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button
                                onClick={exportToPDF}
                                className="ozlistui-refresh-btn"
                                disabled={filteredPartners.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your partner data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view partners'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="ozlistui-table-scroll" style={{ overflowX: 'auto' }}>
                        <div className="ozlistui-table-container">
                            <div className="ozlistui-table-wrapper">
                                <table className="ozlistui-table" style={{ minWidth: '2600px' }}>
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{translations.serialNo || 'S.No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.partnerName || 'Partner Name'}</th>
                                            <th className="ozlistui-centered-cell">{translations.phone || 'Phone'}</th>
                                            <th className="ozlistui-centered-cell">{translations.email || 'Email'}</th>
                                            <th className="ozlistui-centered-cell">{translations.address || 'Address'}</th>
                                            <th className="ozlistui-centered-cell">{translations.partnershipType || 'Partnership Type'}</th>
                                            <th className="ozlistui-centered-cell">{translations.duration || 'Partnership Duration'}</th>
                                            <th className="ozlistui-centered-cell">Contract Start Date</th>
                                            <th className="ozlistui-centered-cell">Contract End Date</th>
                                            <th className="ozlistui-centered-cell">{translations.contract || 'Contract'}</th>
                                            <th className="ozlistui-centered-cell">{translations.investmentAmount || 'Investment Amount'}</th>
                                            <th className="ozlistui-centered-cell">{translations.profitPercent || 'Profit %'}</th>
                                            <th className="ozlistui-centered-cell">{translations.status || 'Status'}</th>
                                            <th className="ozlistui-centered-cell">Expenses/Salaries Included</th>
                                            <th className="ozlistui-centered-cell">{translations.products || 'Selected Products'}</th>
                                            <th className="ozlistui-centered-cell">{translations.description || 'Description'}</th>
                                            <th className="ozlistui-centered-cell">{translations.notes || 'Notes / Remarks'}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{translations.actions || 'Actions'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagination.currentPartners.map((partner, index) => {
                                            const addedBy = partner.username || '-';
                                            const isSelfAdded = addedBy === user?.username;
                                            const hasContract = !!partner.partnership_contract;
                                            const productNames = getProductNames(partner);
                                            
                                            return (
                                                <tr key={partner.partner_id}>
                                                    <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text ozlistui-partner-name">{partner.partner_name || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{partner.phone || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{partner.email || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{partner.address ? (partner.address.length > 25 ? partner.address.substring(0, 25) + '...' : partner.address) : '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className={`ozlistui-badge ozlistui-type-${partner.partnership_type?.toLowerCase().replace(' ', '-') || 'all'}`}>
                                                            {partner.partnership_type === 'ALL'
                                                                ? (translations.allTypeShort || 'All Type')
                                                                : (translations.productBasedShort || 'Product Based')}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell"><span className="ozlistui-cell-text">{partner.partnership_duration || '-'}</span></td>
                                                    <td className="ozlistui-centered-cell"><span className="ozlistui-cell-text">{partner.contract_start_date ? formatDate(partner.contract_start_date) : '-'}</span></td>
                                                    <td className="ozlistui-centered-cell"><span className="ozlistui-cell-text">{partner.contract_end_date ? formatDate(partner.contract_end_date) : '-'}</span></td>
                                                    <td className="ozlistui-centered-cell">
                                                        {hasContract ? (
                                                            <button 
                                                                onClick={() => handleViewContract(partner.partnership_contract)}
                                                                className="ozlistui-action-btn ozlistui-contract-btn"
                                                                title={translations.viewContract || 'View Contract'}
                                                            >
                                                                <FontAwesomeIcon icon={faFileContract} />
                                                                <span className="ozlistui-btn-text-small">View</span>
                                                            </button>
                                                        ) : (
                                                            <span className="ozlistui-no-contract">—</span>
                                                        )}
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{partner.investment_amount != null && partner.investment_amount !== '' ? Number(partner.investment_amount).toFixed(2) : '0.00'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell"><span className="ozlistui-cell-text">{partner.profit_percentage || '0'}%</span></td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className={`ozlistui-status-badge ozlistui-status-${partner.status || 'active'}`}>{partner.status || 'active'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{Number(partner.expenses_salaries_included) === 1 || partner.expenses_salaries_included === true ? 'Yes' : 'No'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text ozlistui-products-text" title={productNames}>
                                                            {productNames !== '-' && productNames.length > 30 ? `${productNames.substring(0, 30)}...` : productNames}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" title={partner.description || ''}>{partner.description ? (partner.description.length > 30 ? `${partner.description.substring(0, 30)}...` : partner.description) : '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" title={partner.notes || ''}>{partner.notes ? (partner.notes.length > 30 ? `${partner.notes.substring(0, 30)}...` : partner.notes) : '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                        <div className="ozlistui-actions-content">
                                                            <button onClick={() => handleView(partner)} className="ozlistui-action-btn ozlistui-view-btn" title={translations.view || 'View'}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </button>
                                                            <button onClick={() => handleEdit(partner)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                            <button 
                                                                onClick={() => handleDeleteClick(partner.partner_id)} 
                                                                className="ozlistui-action-btn ozlistui-delete-btn" 
                                                                title={translations.delete || 'Delete'} 
                                                                disabled={!isSelfAdded} 
                                                                style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {filteredPartners.length > 0 && currentShop && (
                        <div className="ozlistui-pagination">
                            <div className="ozlistui-pagination-info">
                                <span>{translations.showing || 'Showing'} {pagination.startIndex + 1} {translations.of || 'of'} {filteredPartners.length} {translations.partners || 'partners'}</span>
                            </div>
                            <div className="ozlistui-pagination-controls">
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="ozlistui-pagination-btn">
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    <span>{translations.previous || 'Previous'}</span>
                                </button>
                                <div className="ozlistui-page-numbers">
                                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                                        let pageNum;
                                        if (pagination.totalPages <= 5) {
                                            pageNum = i + 1;
                                        } else if (currentPage <= 3) {
                                            pageNum = i + 1;
                                        } else if (currentPage >= pagination.totalPages - 2) {
                                            pageNum = pagination.totalPages - 4 + i;
                                        } else {
                                            pageNum = currentPage - 2 + i;
                                        }
                                        return (
                                            <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                </div>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagination.totalPages} className="ozlistui-pagination-btn">
                                    <span>{translations.next || 'Next'}</span>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* View Modal */}
            {showViewModal && selectedPartner && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faUserTie} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.partnerDetails || 'Partner Details'}</h3>
                                <span className="ozlistui-partner-number-badge">#{selectedPartner.partner_id}</span>
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body ozlistui-view-modal-body">
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faUserTie} />Partner Summary</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.partnerName || 'Partner Name'}:</span><span className="ozlistui-view-value">{selectedPartner.partner_name || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.partnershipType || 'Partnership Type'}:</span><span className="ozlistui-view-value">{selectedPartner.partnership_type === 'ALL' ? 'All Type' : 'Product Based'}</span></div>
                                    {selectedPartner.partnership_type === 'Product Based' && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.products || 'Products'}:</span>
                                            <span className="ozlistui-view-value">{getProductNames(selectedPartner)}</span>
                                        </div>
                                    )}
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.duration || 'Duration'}:</span><span className="ozlistui-view-value">{selectedPartner.partnership_duration || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">Contract Start:</span><span className="ozlistui-view-value">{selectedPartner.contract_start_date ? formatDate(selectedPartner.contract_start_date) : '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">Contract End:</span><span className="ozlistui-view-value">{selectedPartner.contract_end_date ? formatDate(selectedPartner.contract_end_date) : '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.status || 'Status'}:</span>
                                        <span className={`ozlistui-status-badge ozlistui-status-${selectedPartner.status || 'active'}`}>
                                            {selectedPartner.status === 'active' ? 'Active' : selectedPartner.status === 'suspended' ? 'Suspended' : selectedPartner.status === 'terminated' ? 'Terminated' : 'Inactive'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faPhone} />{translations.contactInfo || 'Contact Information'}</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.phone || 'Phone'}:</span><span className="ozlistui-view-value">{selectedPartner.phone || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.email || 'Email'}:</span><span className="ozlistui-view-value">{selectedPartner.email || '-'}</span></div>
                                </div>
                            </div>
                            {selectedPartner.address && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faMapMarkerAlt} />{translations.addressInfo || 'Address Information'}</h4>
                                    <div className="ozlistui-remarks-box">{selectedPartner.address}</div>
                                </div>
                            )}
                            {selectedPartner.description && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faFileAlt} />{translations.description || 'Description'}</h4>
                                    <div className="ozlistui-remarks-box">{selectedPartner.description}</div>
                                </div>
                            )}
                            {selectedPartner.notes && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faStickyNote} />{translations.notes || 'Notes'}</h4>
                                    <div className="ozlistui-remarks-box">{selectedPartner.notes}</div>
                                </div>
                            )}
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faMoneyBillWave} />Financial Details</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.investmentAmount || 'Investment Amount'}:</span>
                                        <span className="ozlistui-view-value">₨ {selectedPartner.investment_amount ? Number(selectedPartner.investment_amount).toFixed(2) : '0.00'}</span>
                                    </div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.profitPercent || 'Profit %'}:</span>
                                        <span className="ozlistui-view-value">{selectedPartner.profit_percentage || '0'}%</span>
                                    </div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">Expenses &amp; Salaries:</span>
                                        <span className="ozlistui-view-value">{Number(selectedPartner.expenses_salaries_included) === 1 || selectedPartner.expenses_salaries_included === true ? 'Included' : 'Not Included'}</span>
                                    </div>
                                </div>
                            </div>
                            {selectedPartner.partnership_contract && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faFileContract} />{translations.contract || 'Contract'}</h4>
                                    <button 
                                        onClick={() => handleViewContract(selectedPartner.partnership_contract)}
                                        className="ozlistui-btn ozlistui-btn-primary ozlistui-btn-sm"
                                    >
                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                        {translations.viewContract || 'View Contract'}
                                    </button>
                                </div>
                            )}
                            <div className="ozlistui-view-section ozlistui-metadata-section">
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.addedBy || 'Added By'}:</span><span className="ozlistui-view-value"><span className="ozlistui-added-by-badge">{selectedPartner.username || '-'}</span></span></div>
                                    {selectedPartner.created_at && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.dateAdded || 'Date Added'}:</span><span className="ozlistui-view-value">{formatDate(selectedPartner.created_at)}</span></div>
                                    )}
                                    {selectedPartner.updated_at && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.lastUpdated || 'Last Updated'}:</span><span className="ozlistui-view-value">{formatDate(selectedPartner.updated_at)}</span></div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                            <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handleEdit(selectedPartner); }}>
                                <FontAwesomeIcon icon={faEdit} />
                                {translations.edit || 'Edit'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {showEditModal && selectedPartner && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div
                        ref={modalRef}
                        className="ozlistui-modal-content ozlistui-edit-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            left: modalPosition.x || '50%',
                            top: modalPosition.y || '50%',
                            transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                            width: modalSize.width,
                            minWidth: '350px',
                            maxWidth: '95vw',
                            maxHeight: '85vh'
                        }}
                    >
                        <div className="ozlistui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                        <div className="ozlistui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                        <div className="ozlistui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                        <div className="ozlistui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                        <div className="ozlistui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                        <div className="ozlistui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                        <div className="ozlistui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                        <div className="ozlistui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                        <div className="ozlistui-modal-header" onMouseDown={startDrag}>
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faEdit} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.editPartner || 'Edit Partner'}</h3>
                                <span className="ozlistui-partner-number-badge">#{selectedPartner.partner_id}</span>
                            </div>
                            <div className="ozlistui-width-control-group">
                                {Object.entries(widthModes).map(([key, mode]) => (
                                    <button key={key} className={`ozlistui-width-btn ${currentWidthMode === key ? 'ozlistui-active' : ''}`} onClick={() => setWidthMode(key)} title={mode.label}>
                                        <FontAwesomeIcon icon={mode.icon} />
                                    </button>
                                ))}
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowEditModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleUpdatePartner}>
                            <div className="ozlistui-modal-body">
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.partner_name ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_partner_name"
                                                name="partner_name"
                                                value={editFormData.partner_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, partner_name: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.partner_name ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_partner_name">
                                                <FontAwesomeIcon icon={faUserTie} />
                                                {translations.partnerName || 'Partner Name'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.partner_name && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.partner_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="tel"
                                                id="edit_phone"
                                                name="phone"
                                                value={editFormData.phone}
                                                onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
                                                placeholder=" "
                                                dir="ltr"
                                            />
                                            <label htmlFor="edit_phone">
                                                <FontAwesomeIcon icon={faPhone} />
                                                {translations.phone || 'Phone'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                        {editFormErrors.phone && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.phone}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.email ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="email"
                                                id="edit_email"
                                                name="email"
                                                value={editFormData.email}
                                                onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_email">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                                {translations.email || 'Email'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                        {editFormErrors.email && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.email}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.partnership_type ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_partnership_type"
                                                name="partnership_type"
                                                value={editFormData.partnership_type}
                                                onChange={(e) => {
                                                    const partnership_type = e.target.value;
                                                    setEditFormData(prev => ({
                                                        ...prev,
                                                        partnership_type,
                                                        selected_products: partnership_type === 'Product Based' ? prev.selected_products : []
                                                    }));
                                                    if (partnership_type === 'Product Based') fetchProductsForEdit();
                                                }}
                                            >
                                                <option value="ALL">All Type Partnership</option>
                                                <option value="Product Based">Product Based Partnership</option>
                                            </select>
                                            <label htmlFor="edit_partnership_type">
                                                <FontAwesomeIcon icon={faHandshake} />
                                                {translations.partnershipType || 'Partnership Type'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.partnership_type && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.partnership_type}
                                            </div>
                                        )}
                                    </div>

                                    {editFormData.partnership_type === 'Product Based' && (
                                        <div className={`ozlistui-form-group ozlistui-full-width ozlistui-edit-products-section ${editFormErrors.selected_products ? 'ozlistui-has-error' : ''}`}>
                                            <div className="ozlistui-input-wrapper ozlistui-products-select-wrapper">
                                                <select
                                                    id="edit_selected_products"
                                                    multiple
                                                    size={Math.min(8, Math.max(3, availableProducts.length))}
                                                    value={editFormData.selected_products.map(String)}
                                                    disabled={loadingProducts}
                                                    onChange={(e) => {
                                                        const selected_products = Array.from(e.target.selectedOptions, option => Number(option.value));
                                                        setEditFormData(prev => ({ ...prev, selected_products }));
                                                        setEditFormErrors(prev => ({ ...prev, selected_products: '' }));
                                                    }}
                                                >
                                                    {availableProducts.map(product => (
                                                        <option key={product.id} value={product.id}>
                                                            {product.product_name}{product.batch_no ? ` — ${product.batch_no}` : ''}{product.quantity != null ? ` (Qty: ${product.quantity})` : ''}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="edit_selected_products">
                                                    <FontAwesomeIcon icon={faBoxes} />
                                                    {loadingProducts ? 'Loading Products...' : 'Selected Products'} <span className="ozlistui-required">*</span>
                                                </label>
                                            </div>
                                            {editFormErrors.selected_products && <div className="ozlistui-error-message">{editFormErrors.selected_products}</div>}
                                            <small className="ozlistui-products-help">
                                                {editFormData.selected_products.length} product(s) selected. Hold Ctrl (Windows) or Command (Mac) to select multiple products.
                                            </small>
                                        </div>
                                    )}

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_partnership_duration"
                                                name="partnership_duration"
                                                value={editFormData.partnership_duration}
                                                onChange={(e) => setEditFormData({ ...editFormData, partnership_duration: e.target.value })}
                                            >
                                                <option value="">Select Duration</option>
                                                <option value="3_months">3 Months</option>
                                                <option value="6_months">6 Months</option>
                                                <option value="1_year">1 Year</option>
                                                <option value="2_years">2 Years</option>
                                                <option value="3_years">3 Years</option>
                                                <option value="5_years">5 Years</option>
                                                <option value="lifetime">Lifetime</option>
                                                <option value="custom">Custom Duration</option>
                                            </select>
                                            <label htmlFor="edit_partnership_duration">
                                                <FontAwesomeIcon icon={faClock} />
                                                {translations.duration || 'Duration'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_investment_amount"
                                                name="investment_amount"
                                                value={editFormData.investment_amount}
                                                onChange={(e) => setEditFormData({ ...editFormData, investment_amount: e.target.value })}
                                                placeholder=" "
                                                step="0.01"
                                                min="0"
                                            />
                                            <label htmlFor="edit_investment_amount">
                                                <FontAwesomeIcon icon={faMoneyBillWave} />
                                                {translations.investmentAmount || 'Investment Amount'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_profit_percentage"
                                                name="profit_percentage"
                                                value={editFormData.profit_percentage}
                                                onChange={(e) => setEditFormData({ ...editFormData, profit_percentage: e.target.value })}
                                                placeholder=" "
                                                step="0.01"
                                                min="0"
                                                max="100"
                                            />
                                            <label htmlFor="edit_profit_percentage">
                                                <FontAwesomeIcon icon={faPercent} />
                                                {translations.profitPercent || 'Profit %'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_contract_start_date"
                                                name="contract_start_date"
                                                value={editFormData.contract_start_date}
                                                onChange={(e) => setEditFormData({ ...editFormData, contract_start_date: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_contract_start_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                Contract Start
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_contract_end_date"
                                                name="contract_end_date"
                                                value={editFormData.contract_end_date}
                                                onChange={(e) => setEditFormData({ ...editFormData, contract_end_date: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_contract_end_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                Contract End
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_status"
                                                name="status"
                                                value={editFormData.status}
                                                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                                <option value="suspended">Suspended</option>
                                                <option value="terminated">Terminated</option>
                                            </select>
                                            <label htmlFor="edit_status">
                                                <FontAwesomeIcon icon={faIdCard} />
                                                {translations.status || 'Status'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_expenses_salaries_included"
                                                value={editFormData.expenses_salaries_included ? '1' : '0'}
                                                onChange={(e) => setEditFormData(prev => ({ ...prev, expenses_salaries_included: e.target.value === '1' }))}
                                            >
                                                <option value="1">Include Expenses &amp; Salary</option>
                                                <option value="0">Do not include Expenses &amp; Salary</option>
                                            </select>
                                            <label htmlFor="edit_expenses_salaries_included">
                                                <FontAwesomeIcon icon={faMoneyBillWave} /> Expenses &amp; Salaries
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="file"
                                                id="edit_partnership_contract"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                onChange={(e) => setEditContractFile(e.target.files?.[0] || null)}
                                            />
                                            <label htmlFor="edit_partnership_contract">
                                                <FontAwesomeIcon icon={faFileContract} /> Replace Partnership Contract
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                        {editFormData.partnership_contract && !editContractFile && (
                                            <small>Current file: {editFormData.partnership_contract}</small>
                                        )}
                                        {editContractFile && <small>New file: {editContractFile.name}</small>}
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <textarea
                                                id="edit_address"
                                                name="address"
                                                value={editFormData.address}
                                                onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
                                                rows="2"
                                                placeholder=" "
                                            ></textarea>
                                            <label htmlFor="edit_address">
                                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                                {translations.address || 'Address'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <textarea
                                                id="edit_description"
                                                name="description"
                                                value={editFormData.description}
                                                onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
                                                rows="2"
                                                placeholder=" "
                                            ></textarea>
                                            <label htmlFor="edit_description">
                                                <FontAwesomeIcon icon={faFileAlt} />
                                                {translations.description || 'Description'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <textarea
                                                id="edit_notes"
                                                name="notes"
                                                value={editFormData.notes}
                                                onChange={(e) => setEditFormData({ ...editFormData, notes: e.target.value })}
                                                rows="2"
                                                placeholder=" "
                                            ></textarea>
                                            <label htmlFor="edit_notes">
                                                <FontAwesomeIcon icon={faStickyNote} />
                                                {translations.notes || 'Notes'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ozlistui-modal-footer">
                                <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowEditModal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                    {translations.cancel || 'Cancel'}
                                </button>
                                <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={editLoading}>
                                    {editLoading ? (
                                        <>
                                            <div className="ozlistui-btn-spinner"></div>
                                            <span>{translations.updating || 'Updating...'}</span>
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faSave} />
                                            <span>{translations.saveChanges || 'Save Changes'}</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>{translations.deleteMessage || 'Are you sure you want to delete this partner?'}</p>
                                <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SolarPartnersList;
